<template>
  <div style="position:absolute;left: 20px;top:10px;z-index: 99999" v-drag="'.header'">
    <div style="position:relative">
      <div style="padding: 10px;color:white;background-color:#43A2FF;cursor:move;min-width: 200px;position: relative;text-align: left;" class="header">
        <div style=";margin: 0 auto;padding: 3px;width: 100%;text-align: center;">Admin notes</div>
      </div>
      <div style="color: white;padding: 5px;cursor: pointer;display: inline-block;z-index: 999999;position: absolute;left: 10px;top: 7px" @click="toggleCollapse">
        <span style="font-size: 12px;" v-if="this.collapsed">Expand</span>
        <span style="font-size: 12px;" v-else>Collapse</span>
      </div>
      <div style=" position: absolute;display: inline-block;right: 10px;top: 7px;padding: 5px;color: white;">
        <span v-if="saving" style=" font-size:12px">Saving...</span>
      </div>
    </div>
    <div v-if="!collapsed">
      <div style="display:flex">
        <div>
        <textarea rows="3" cols="40" v-model="text" style="padding: 5px">
        </textarea>
        </div>
        <button style="padding: 10px;color:white;background-color: #333;cursor:pointer" @click="addMessage">Add</button>
      </div>
      <div v-if="history.length" style="border-left:1px solid black;border-right:1px solid black;background-color: #eee;max-width: 448px;max-height: 200px;overflow: scroll;display:flex;flex-direction: column;">
        <div v-for="entry in history" style="border-bottom:1px solid #aaa;padding: 8px;text-align: left;">
          <div style="font-weight: bold;margin-bottom: 5px;">{{ formatDate(entry.createdAt) }}, {{ (entry.createdBy || 'agent@-' ).split('@')[0] }}: </div>
          <MarkdownIt :content="entry.text" :options="{markdownIt: {breaks: true, linkify: true}}"/>
        </div>
      </div>
      <div v-if="tags.length" style="display:flex;border:1px solid black;align-items: center;padding:10px;background-color: #eee;">
        <div style="max-width: 380px;text-align: left; line-height: 28px;">
          <div v-for="tag in tags" :style="getTagStyle(tag)">{{ tag }} <span style="font-weight:bolder;cursor: pointer;" @click="removeTag(tag)">x</span></div>
        </div>
      </div>
      <div style="display:flex;justify-content: space-between;border:1px solid black;align-items: center;border-top:0;padding-left:10px;background-color: #eee;padding 5px">
        <div v-if="pinnable">
          <input id="pin" name="pin" type="checkbox" v-model="pinned" @change="pinNote($event)" />
          <label for="pin" style="margin-left:10px">Pin item</label>
        </div>
        <div v-else></div>
        <div>
          <input placeholder="Add Tag" v-model="tagSearch" style="width: 274px; padding: 3px" @input="getTagSuggestions" @focus="getTagSuggestions" @blur="blurSuggestions" />
          <div style="position: absolute; background-color: white;width: 180px;">
            <div style="padding: 5px;border-top: 1px solid gray; cursor: pointer;" v-for="tag in tagSuggestions" @click="addTag(tag)">{{ tag.label }}{{ tag.new ? ' (NEW)' : '' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../services/api";
import MarkdownIt from "markdown-it-vue";
import dayjs from "dayjs";

export default {
  components: { MarkdownIt },
  props: {
    objectId: {
      type: String,
    },
    collection: {
      type: String,
    },
    pinnable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      collapsed: false,
      saving: false,
      pinned: false,
      text: '',
      tags: [],
      tagSuggestions: [],
      availableTags: [],
      history: [],
      tagSearch: ''
    }
  },
  async created() {
    const note = await api.getNote(this.collection, this.objectId);
    this.pinned = note.pinnedAt ? true : false;
    this.tags = note.tags || [];
    this.history = (note.history || []).reverse();
    if (note.text) {
      this.history.push({text: note.text});
    }
    if (!this.tags.length && !this.history.length) {
      this.collapsed = true;
    }
    this.availableTags = (this.$store.state.config.tags || []).sort((a, b) => a.label > b.label);
  },
  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed;
    },
    formatDate(d) {
      if (!d) {
        return '-';
      }
      return dayjs(d._seconds ? d._seconds  * 1000 : d).format('YYYY-MM-DD HH:mm');
    },
    getTagSuggestions() {
      const term = (this.tagSearch || '').trim().toLowerCase().replace(/\s+/g, '');

      this.tagSuggestions = [];
      if (term) {
        this.tagSuggestions = [{label: term, new: true}];
      }
      this.availableTags.forEach(tag => {
        if ((term && tag.label.includes(term)) || !term) {
          this.tagSuggestions.push(tag);
        }
      });
    },
    blurSuggestions() {
      setTimeout(() => {this.tagSuggestions=[]}, 250);
    },
    async addMessage(m) {
      if (this.saving) {
        return;
      }
      this.saving = true;
      const message = await api.addNoteMessage(this.collection, this.objectId, {
        text: this.text,
      });
      this.history.unshift(message);
      this.text = '';
      // console.log('Add message', this.text);
      this.saving = false;
    },
    async addTag(t) {
      let tag = Object.assign({}, t);
      if (this.tags.includes(tag.label)) {
        return;
      }
      const isNew = tag.new;
      delete tag.new;
      this.saving = true;
      if (isNew) {
        tag = await api.createTag(tag);
      }
      this.tags.push(tag.label);
      if (isNew) {
        this.availableTags.push(tag);
      }
      await api.saveNote(this.collection, this.objectId, {
        // text: this.text,
        pin: this.pinned,
        tags: this.tags
      });
      this.saving = false;
      this.tagSuggestions = [];
      this.tagSearch = '';
    },
    async removeTag(tag) {
      this.tags = this.tags.filter(t => t !== tag);
      this.saving = true;
      await api.saveNote(this.collection, this.objectId, {
        // text: this.text,
        pin: this.pinned,
        tags: this.tags
      });
      this.saving = false;
      this.tagSuggestions = [];
    },
    getTagStyle(label) {
      for (let i = 0; i < this.availableTags.length; i++) {
        const tag = this.availableTags[i];
        if (tag.label === label) {
          return `display:inline-block;backgroundColor: ${tag.backgroundColor}; color: ${tag.foregroundColor};padding: 3px;border-radius: 3px;margin-right:5px;font-weight: bold`;
        }
      }
    },
    async saveNote() {
      this.saving = true;
      await api.saveNote(this.collection, this.objectId, {
        // text: this.text,
        pin: this.pinned,
        tags: this.tags
      });
      this.saving = false;
    },
    async pinNote(ev) {
      this.$nextTick(async () => {
        this.saving = true;
        await api.saveNote(this.collection, this.objectId, {
          // text: this.text,
          pin: this.pinned,
          tags: this.tags
        });
        this.saving = false;
      });
    }
  }
}
</script>
